// @flow
import * as React from 'react';

type Props = {|
  className: string,
  children: React.Node,
|};

const SocialSection = ({ className, children }: Props) => (
  <div className={`${className} ui_card section`}>{children}</div>
);

export default SocialSection;
